import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["onDelete", "icon", "inputSize"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Icon } from '@elements/icon';
import { StyledChip } from './chip.styles';
import CloseCircle from '@images/close-circle.svg';
import { jsx as _jsx } from "react/jsx-runtime";
var Chip = function Chip(_ref) {
  var onDelete = _ref.onDelete,
    icon = _ref.icon,
    inputSize = _ref.inputSize,
    restProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(StyledChip, _objectSpread(_objectSpread({}, restProps), {}, {
    withIcon: !!icon,
    withDelete: !!onDelete,
    icon: icon,
    onDelete: onDelete,
    deleteIcon: /*#__PURE__*/_jsx(Icon, {
      src: CloseCircle,
      width: inputSize === 'large' ? 24 : 20,
      height: inputSize === 'large' ? 24 : 20
    })
  }));
};
export { Chip };